"use strict";
// https://getbootstrap.com/docs/5.3/layout/breakpoints/#available-breakpoints
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
// Bootstrap breakpoints / window widths
exports.breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
